// `event:key` composite for once-per-key dedup (`${name}:${dedupeKey}`). Event
// names are space-separated with no symbols, so the colon can't collide with an
// unkeyed name or another `(event, key)` split.
const KEY_SEPARATOR = ':';
/**
 * Resolves a track call's dedup-set entry: the bare event name, the
 * `event:key` composite, or `null` when the call doesn't dedup.
 */
export function computeOnceKey(event, once) {
    if (once === undefined || once === false) {
        return null;
    }
    if (once === true) {
        return event;
    }
    if (!once.enabled) {
        return null;
    }
    return once.key === undefined ? event : `${event}${KEY_SEPARATOR}${String(once.key)}`;
}
//# sourceMappingURL=computeOnceKey.js.map